<template>
  <div class="tag-new rounded-circle d-flex flex-column align-items-center justify-content-center">
    <div>NEW</div>
  </div>
</template>

<script>
export default {
  name: 'TagDiscount'
}
</script>

<style scoped>
.tag-new {
  width: 48px;
  height: 48px;
  background-color: #9FADB3;
  color: white;
  font-size: 14px;
  font-family: 'Noto Serif TC', serif;
  font-weight: 700;
  line-height: 1;
}
</style>
